import script from "./MaterialOrdering.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialOrdering.vue?vue&type=script&setup=true&lang=js"

import "./MaterialOrdering.vue?vue&type=style&index=0&id=806ced14&scoped=true&lang=css"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-806ced14"]])

export default __exports__